<div class="FcAgEditor__MenuItem--IconContainer" [innerHTML]="icon | sanitizeHtml"
     (click)="fileInput.click()"
     [title]="getLabel('insertImage')">
</div>

<input  style="display: none"
        accept=".jpg, .jpeg, .png"
        type="file"
        (change)="insertImageHandler($event)"
        #fileInput>